'use strict';

var React = require('react');
var Hls = require('hls.js');
var react = require('@emotion/react');
var styled = require('@emotion/styled');
var reactTransitionGroup = require('react-transition-group');
var screenfull = require('screenfull');
var mobileDeviceDetect = require('mobile-device-detect');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Hls__default = /*#__PURE__*/_interopDefaultLegacy(Hls);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var screenfull__default = /*#__PURE__*/_interopDefaultLegacy(screenfull);

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function useCurrentWidth() {
  var isClient = typeof window === 'object';

  var getWidth = function getWidth() {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  };

  var _useState = React.useState(isClient ? getWidth() : undefined),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  React.useEffect(function () {
    if (!isClient) {
      return undefined;
    }

    var resizeListener = function resizeListener() {
      return setWidth(getWidth());
    };

    window.addEventListener('resize', resizeListener);
    return function () {
      window.removeEventListener('resize', resizeListener);
    };
  }, []);
  return width;
}

function getStoragePlayerSettings() {
  var settings = localStorage.getItem('sparky-player-settings');

  try {
    var parsed = JSON.parse(settings || '{}');
    return parsed;
  } catch (e) {
    localStorage.removeItem('sparky-player-settings');
    return null;
  }
}
function setStoragePlayerSettings(settings) {
  var _ref;

  var currentSettings = (_ref = getStoragePlayerSettings()) !== null && _ref !== void 0 ? _ref : {};
  var nextSettings = {};

  if (currentSettings) {
    Object.keys(currentSettings).forEach(function (key) {
      nextSettings[key] = currentSettings[key];
    });
  }

  Object.keys(settings).forEach(function (key) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    nextSettings[key] = settings[key];
  });
  localStorage.setItem('sparky-player-settings', JSON.stringify(nextSettings));
}
function formatDigitToHHmmss(digit, zeroPad, displayHour) {
  var startTime = digit;
  var NumberedStartTime = new Date(startTime * 1000);
  var utcStartTime = NumberedStartTime.toUTCString();
  var formattedStartTime = startTime >= 3600 || displayHour ? utcStartTime.replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1') : utcStartTime.replace(/.*(\d{2}:\d{2}).*/, '$1');

  if (!zeroPad) {
    return formattedStartTime.startsWith('0') ? formattedStartTime.substr(1, formattedStartTime.length) : formattedStartTime;
  } else {
    return formattedStartTime;
  }
}
function getVideoThumbnailUrl(thumbnails) {
  var quality = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'highest';
  var useBaseUrl = arguments.length > 2 ? arguments[2] : undefined;
  if (!thumbnails || !thumbnails.length) return '/static/assets/common/default_thumbnail.png'; // [TODO] !thumbnails

  var target = thumbnails.sort(function (a, b) {
    return b.metadata.width - a.metadata.width;
  })[quality === 'highest' ? 0 : thumbnails.length - 1];

  if (useBaseUrl && target.url.includes('amazonaws.com')) {
    // [TODO] useBaseUrl && target.url.includes('amazonaws.com')
    return process.env.NEXT_PUBLIC_CDN_VIDEO_BASEURL + target.url.split('amazonaws.com')[1];
  }

  return target.url;
}

var PlayerStatus;

(function (PlayerStatus) {
  PlayerStatus[PlayerStatus["INITIALIZING"] = 0] = "INITIALIZING";
  PlayerStatus[PlayerStatus["WAITING_FOR_CHOOSE"] = 1] = "WAITING_FOR_CHOOSE";
  PlayerStatus[PlayerStatus["PLAYING"] = 2] = "PLAYING";
  PlayerStatus[PlayerStatus["PAUSED"] = 3] = "PAUSED";
  PlayerStatus[PlayerStatus["SINGLEPLAYING"] = 4] = "SINGLEPLAYING";
})(PlayerStatus || (PlayerStatus = {}));

var _templateObject$2, _templateObject2$2;
var scMixinAbsoluteFull = react.css(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"])));
var scMixinPseudoBlock = react.css(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  display: block;\n  content: '';\n"])));

var _templateObject$1, _templateObject2$1;
var scAnimPlayerInteractionFeedbackCircle = react.keyframes(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n    transform: scale(0.7);\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n    transform: scale(1.3);\n  }\n"])));
var scAnimBufferingIndcSpinner = react.keyframes(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n  \n  to {\n    transform: rotate(359deg);\n  }\n"])));

var en = {
	"watch.choosable.play": "View",
	"watch.choosable.singleplay": "Game Start",
	"watch.choosable.singleplay.authreq": "Log in to play",
	"watch.choosable.multiplay": "Multiplayer",
	"player.mobile.unmute": "Tap to unmute"
};
var ko = {
	"watch.choosable.play": "동영상 재생",
	"watch.choosable.singleplay": "게임시작",
	"watch.choosable.singleplay.authreq": "로그인 후 게임",
	"watch.choosable.multiplay": "멀티게임",
	"player.mobile.unmute": "탭하여 음소거 해제"
};
var vi = {
	"watch.choosable.play": "Xem",
	"watch.choosable.singleplay": "Trò chơi bắt đầu",
	"watch.choosable.singleplay.authreq": "Đăng nhập để chơi",
	"watch.choosable.multiplay": "Nhiều người chơi",
	"player.mobile.unmute": "Bấm để tắt tiếng"
};
var fr = {
	"watch.choosable.play": "Vue",
	"watch.choosable.singleplay": "Commencer le jeu",
	"watch.choosable.singleplay.authreq": "Connectez-vous pour jouer",
	"watch.choosable.multiplay": "Multiplayer",
	"player.mobile.unmute": "Appuyez sur pour unmute"
};
var pt = {
	"watch.choosable.play": "Visualizar",
	"watch.choosable.singleplay": "Início do jogo",
	"watch.choosable.singleplay.authreq": "Faça o login para jogar",
	"watch.choosable.multiplay": "Multiplayer",
	"player.mobile.unmute": "Partilhar"
};
var es = {
	"watch.choosable.play": "Vista",
	"watch.choosable.singleplay": "Empezar juego",
	"watch.choosable.singleplay.authreq": "Iniciar sesión para jugar",
	"watch.choosable.multiplay": "Multijugador",
	"player.mobile.unmute": "Toque para desmontar"
};
var it = {
	"watch.choosable.play": "Visualizzazione",
	"watch.choosable.singleplay": "Inizio del gioco",
	"watch.choosable.singleplay.authreq": "Accedi per giocare",
	"watch.choosable.multiplay": "Più giocatori ",
	"player.mobile.unmute": "Condividi"
};
var ja = {
	"watch.choosable.play": "意見",
	"watch.choosable.singleplay": "ゲーム開始",
	"watch.choosable.singleplay.authreq": "再生にログインします",
	"watch.choosable.multiplay": "マルチプレイヤー",
	"player.mobile.unmute": "共有"
};
var zh = {
	"watch.choosable.play": "看法",
	"watch.choosable.singleplay": "游戏开始",
	"watch.choosable.singleplay.authreq": "登录播放",
	"watch.choosable.multiplay": "多人游戏",
	"player.mobile.unmute": "点击取消静音"
};
var ru = {
	"watch.choosable.play": "Вид",
	"watch.choosable.singleplay": "Начало игры",
	"watch.choosable.singleplay.authreq": "Войдите, чтобы играть",
	"watch.choosable.multiplay": "Многопользовательский",
	"player.mobile.unmute": "Поделиться"
};
var LocaleJson = {
	en: en,
	ko: ko,
	vi: vi,
	fr: fr,
	pt: pt,
	"pt-BR": {
	"watch.choosable.play": "Visualizar",
	"watch.choosable.singleplay": "Início do jogo",
	"watch.choosable.singleplay.authreq": "Faça o login para jogar",
	"watch.choosable.multiplay": "Multiplayer",
	"player.mobile.unmute": "Partilhar"
},
	es: es,
	it: it,
	ja: ja,
	zh: zh,
	ru: ru
};

var locale = LocaleJson;

var _path$c;

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

function SvgIcoSpPlay(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$c({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$c || (_path$c = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M6.926 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18a1 1 0 000-1.69l-8.14-5.17a.998.998 0 00-1.54.84z",
    fill: "#F5F6F8"
  })));
}

var _path$b;

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

function SvgIcoSpPause(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$b({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17c0 1.1-.9 2-2 2s-2-.9-2-2V7c0-1.1.9-2 2-2s2 .9 2 2v10zm4 0V7c0-1.1.9-2 2-2s2 .9 2 2v10c0 1.1-.9 2-2 2s-2-.9-2-2z",
    fill: "#F5F6F8"
  })));
}

var _path$a;

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

function SvgIcoSpRestart(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$a({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$a || (_path$a = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M17.642 6.352a7.95 7.95 0 00-6.48-2.31c-3.67.37-6.69 3.35-7.1 7.02-.55 4.85 3.2 8.94 7.93 8.94a7.98 7.98 0 007.21-4.56c.32-.67-.16-1.44-.9-1.44-.37 0-.72.2-.88.53a5.994 5.994 0 01-6.8 3.31c-2.22-.49-4.01-2.3-4.48-4.52a6.002 6.002 0 015.85-7.32c1.66 0 3.14.69 4.22 1.78l-1.51 1.51c-.63.63-.19 1.71.7 1.71h3.59c.55 0 1-.45 1-1v-3.59c0-.89-1.08-1.34-1.71-.71l-.64.65z",
    fill: "#F5F6F8"
  })));
}

var _path$9;

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

function SvgIcoSpVolumeHigh(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$9({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4.652v-.2c0-.63.63-1.08 1.21-.85a8.98 8.98 0 015.79 8.4c0 3.84-2.4 7.11-5.79 8.4-.58.22-1.21-.22-1.21-.85v-.2c0-.38.24-.71.6-.85a7.004 7.004 0 004.4-6.5c0-2.94-1.82-5.47-4.4-6.5a.93.93 0 01-.6-.85zm-11 5.35v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.412c0-.89-1.08-1.34-1.71-.71L7 9.002H4c-.55 0-1 .45-1 1zm13.5 2a4.5 4.5 0 00-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z",
    fill: "#F5F6F8"
  })));
}

var _path$8;

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function SvgIcoSpVolumeMid(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$8({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 14.002v-4c0-.55.45-1 1-1h3l3.29-3.3c.63-.63 1.71-.18 1.71.71v11.17c0 .89-1.08 1.34-1.71.71L7 15.002H4c-.55 0-1-.45-1-1zm11-6.03a4.5 4.5 0 012.5 4.03c0 1.77-1.02 3.29-2.5 4.02v-8.05z",
    fill: "#F5F6F8"
  })));
}

var _path$7;

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function SvgIcoSpVolumeMuted(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$7({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.63 5.045a.996.996 0 010-1.41c.4-.39 1.03-.39 1.42 0l15.31 15.32a.996.996 0 11-1.41 1.41l-1.34-1.34c-.67.54-1.42.98-2.22 1.31-.66.27-1.39-.19-1.39-.91 0-.39.22-.77.58-.92.58-.23 1.11-.54 1.6-.91L12 13.415v4.17c0 .89-1.08 1.34-1.71.71L7 15.005H4c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3l.29-.3-3.66-3.66zm14.96 9.3c.26-.73.41-1.52.41-2.34 0-2.94-1.82-5.46-4.39-6.5-.36-.14-.61-.47-.61-.85v-.19c0-.63.63-1.09 1.22-.86a8.995 8.995 0 015.78 8.4c0 1.39-.32 2.7-.88 3.87l-1.53-1.53zm-8.3-8.63l-.17.17L12 7.765v-1.35c0-.89-1.08-1.33-1.71-.7zM14 7.975a4.5 4.5 0 012.5 4.03c0 .08-.01.16-.02.24L14 9.765v-1.79z",
    fill: "#F5F6F8"
  })));
}

var _path$6;

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

function SvgIcoSpFullscreenEnter(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$6({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4v8H2V2h10v2H4zm11.707 5.707L20 5.414V9h2V2h-7v2h3.586l-4.293 4.293 1.414 1.414zM20 12v8h-8v2h10V12h-2zM9 22v-2H5.414l4.293-4.293-1.414-1.414L4 18.586V15H2v7h7z",
    fill: "#F5F6F8"
  })));
}

var _path$5;

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function SvgIcoSpFullscreenExit(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$5({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.864 6.864L19.727 3 21 4.273l-3.864 3.864h3.228v1.8h-6.3v-6.3h1.8v3.227zM19.2 19.2V12H21v9h-9v-1.8h7.2zM4.8 4.8V12H3V3h9v1.8H4.8zM3.638 15.864v-1.8h6.3v6.3h-1.8v-3.228L4.274 21 3 19.727l3.864-3.863H3.638z",
    fill: "#F5F6F8"
  })));
}

var _path$4, _path2$1, _path3;

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function SvgIcoSpChoosePlay(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$4({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M70 35c0 19.33-15.67 35-35 35S0 54.33 0 35 15.67 0 35 0s35 15.67 35 35z",
    fill: "#8100FF"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M64.22 35.11c0 16.077-13.033 29.11-29.11 29.11C19.033 64.22 6 51.187 6 35.11 6 19.033 19.033 6 35.11 6c16.077 0 29.11 13.033 29.11 29.11z",
    fill: "#F5F6F8"
  })), _path3 || (_path3 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M29.82 49.631L46.287 36.95a1.828 1.828 0 000-2.898L29.821 21.369c-1.164-.906-2.821-.037-2.821 1.45v25.363c0 1.485 1.657 2.355 2.82 1.45z",
    fill: "#8100FF"
  })));
}

var _circle, _path$3;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function SvgIcoSpChooseSingleplay(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$3({
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React__namespace.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#52C41A"
  })), _path$3 || (_path$3 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.89 34.999C5.89 18.929 18.929 5.891 35 5.891c16.07 0 29.108 13.037 29.108 29.108 0 16.07-13.037 29.108-29.108 29.108C18.929 64.107 5.891 51.07 5.891 35zm27.593 5.074v12.075c0 1.546 2.071 2.042 2.771.642l10.384-20.767c.466-.962-.234-2.1-1.313-2.1h-7.408v-12.22c0-1.546-2.071-2.042-2.742-.671L24.442 37.944c-.525.963.204 2.13 1.283 2.13h7.758z",
    fill: "#F5F6F8"
  })));
}

var _path$2;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function SvgIcoSpVolumeMobileUnmute(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.63 1.703a.996.996 0 010-1.41c.4-.39 1.03-.39 1.42 0l15.31 15.324a.996.996 0 11-1.41 1.41l-1.34-1.34c-.67.54-1.42.98-2.22 1.31-.66.27-1.39-.19-1.39-.91 0-.39.22-.77.58-.92.58-.23 1.11-.54 1.6-.91L9 10.075v4.172c0 .89-1.08 1.34-1.71.71L4 11.666H1c-.55 0-1-.45-1-1V6.664c0-.55.45-1 1-1h3l.29-.3L.63 1.703zm14.96 9.302c.26-.73.41-1.52.41-2.34 0-2.941-1.82-5.462-4.39-6.502-.36-.14-.61-.47-.61-.85v-.19c0-.63.63-1.09 1.22-.86A8.997 8.997 0 0118 8.664c0 1.39-.32 2.7-.88 3.87l-1.53-1.53zM7.291 2.373l-.17.17 1.88 1.88v-1.35c0-.89-1.08-1.33-1.71-.7zM11 4.634c1.48.74 2.5 2.261 2.5 4.032 0 .08-.01.16-.02.24L11 6.425v-1.79z",
    fill: "#090909"
  })));
}

var _path$1, _path2;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function SvgIcoSpSeekPrev(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.047 13.649c.5 0 .91.37.98.86a6.006 6.006 0 007.42 4.96c2.25-.54 3.91-2.27 4.39-4.53a6.014 6.014 0 00-5.87-7.29v2.79c0 .45-.54.67-.85.35l-3.79-3.79c-.2-.2-.2-.51 0-.71l3.79-3.79a.5.5 0 01.85.35v2.8c4.94 0 8.84 4.48 7.84 9.6-.6 3.11-2.9 5.5-5.99 6.19-4.83 1.08-9.15-2.2-9.77-6.67-.09-.59.4-1.12 1-1.12z",
    fill: "#F5F6F8"
  })), _path2 || (_path2 = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12.513 15.799c-.05.07-.11.13-.18.17-.07.04-.17.06-.27.06a.6.6 0 01-.42-.15.633.633 0 01-.19-.41h-.84c.01.2.05.37.13.53.08.16.19.28.32.39.13.11.29.19.46.24.17.05.35.08.53.08.24 0 .46-.04.64-.12.18-.08.33-.18.45-.31s.21-.28.27-.45c.06-.17.09-.35.09-.54 0-.22-.03-.43-.09-.6a1.31 1.31 0 00-.25-.45c-.11-.12-.25-.22-.41-.28-.16-.06-.34-.1-.55-.1-.07 0-.14.01-.2.02s-.13.02-.18.04c-.05.02-.1.03-.15.05-.05.02-.08.04-.11.05l.11-.92h1.7v-.71h-2.39l-.25 2.17.67.17c.03-.03.06-.06.1-.09.04-.03.07-.05.12-.07.05-.02.1-.04.15-.05.05-.01.13-.02.2-.02.12 0 .22.02.3.05.08.03.16.09.21.15.05.06.1.14.13.24.03.1.04.19.04.31s-.01.22-.03.31c-.02.09-.06.17-.11.24z",
    fill: "#F5F6F8"
  })));
}

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgIcoSpSeekNext(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.973 14.508c.07-.49.48-.86.98-.86.6 0 1.09.53 1 1.12-.62 4.47-4.94 7.75-9.77 6.67-3.09-.69-5.39-3.08-5.99-6.19-1-5.12 2.9-9.6 7.84-9.6v-2.8a.5.5 0 01.85-.35l3.79 3.79c.2.2.2.51 0 .71l-3.79 3.79c-.31.32-.85.1-.85-.35v-2.79c-3.73 0-6.68 3.42-5.87 7.29.48 2.26 2.14 3.99 4.39 4.53 3.65.88 6.94-1.59 7.42-4.96zm-5.64 1.46c.07-.04.13-.1.18-.17.05-.07.09-.15.11-.24.02-.09.03-.19.03-.31s-.01-.21-.04-.31a.681.681 0 00-.13-.24.538.538 0 00-.21-.15.853.853 0 00-.3-.05c-.07 0-.15.01-.2.02-.05.01-.1.03-.15.05-.05.02-.08.04-.12.07-.04.03-.07.06-.1.09l-.67-.17.25-2.17h2.39v.71h-1.7l-.11.92c.015-.005.03-.012.047-.02a.766.766 0 01.138-.054c.025-.008.05-.016.075-.026.044-.017.105-.027.16-.036l.02-.003c.06-.01.13-.02.2-.02.21 0 .39.04.55.1.16.06.3.16.41.28.11.12.19.28.25.45.06.17.09.38.09.6 0 .19-.03.37-.09.54-.06.17-.15.32-.27.45-.12.13-.27.23-.45.31-.18.08-.4.12-.64.12-.18 0-.36-.03-.53-.08-.17-.05-.33-.13-.46-.24-.13-.11-.24-.23-.32-.39-.08-.16-.12-.33-.13-.53h.84c.02.17.08.31.19.41.11.1.25.15.42.15.1 0 .2-.02.27-.06z",
    fill: "#F5F6F8"
  })));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;

// comment
var Player = function Player(_ref) {
  var _video$duration, _video$thumbnails, _options$playsinline, _options$muted, _video$thumbnails2;

  var video = _ref.video,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {
    autoplay: true
  } : _ref$options,
      auth = _ref.auth,
      _ref$isAuthenticated = _ref.isAuthenticated,
      isAuthenticated = _ref$isAuthenticated === void 0 ? false : _ref$isAuthenticated;
      _ref.isEmbedded;
      var _ref$isFeedbackPlayin = _ref.isFeedbackPlaying,
      isFeedbackPlaying = _ref$isFeedbackPlayin === void 0 ? false : _ref$isFeedbackPlayin,
      $callbackOnLoaded = _ref.onLoaded;
      _ref.onClickVideoPlay;
      var onClickSingleplay = _ref.onClickSingleplay,
      id = _ref.id,
      _ref$locale = _ref.locale,
      locale$1 = _ref$locale === void 0 ? 'en' : _ref$locale;
  var containerRef = React.useRef(null);
  var controlsRef = React.useRef(null);
  var videoContainerRef = React.useRef(null);
  var videoRef = React.useRef(null);
  var hlsInstance = React.useRef(); // TODO :: initialize or undefined ?

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      builtInHls = _useState2[0],
      setBuiltInHls = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2);
      _useState4[0];
      var setMounted = _useState4[1];

  var clientWidth = useCurrentWidth();
  var isTouchDevice = React.useRef(false);

  var _useState5 = React.useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      userInteractionState = _useState6[0],
      setUserInteractionState = _useState6[1];

  var userInteractionFeedbackCircleTimeoutHandler = React.useRef(0);
  var isSeekingMouseDown = React.useRef(false);
  var isVolumeSliderMouseDown = React.useRef(false);

  var _useState7 = React.useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      onMouseOver = _useState8[0],
      setMouseOver = _useState8[1];

  var _useState9 = React.useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      onMouseOverControls = _useState10[0],
      setMouseOverControls = _useState10[1];

  var _useState11 = React.useState(video.src.metadata.extension),
      _useState12 = _slicedToArray(_useState11, 1);
      _useState12[0];

  var _useState13 = React.useState([]),
      _useState14 = _slicedToArray(_useState13, 2);
      _useState14[0];
      var setLevels = _useState14[1];

  var _useState15 = React.useState(PlayerStatus.INITIALIZING),
      _useState16 = _slicedToArray(_useState15, 2),
      status = _useState16[0],
      setStatus = _useState16[1];

  var _useState17 = React.useState(null),
      _useState18 = _slicedToArray(_useState17, 2),
      hoveredChoosePanel = _useState18[0],
      setHoveredChoosePanel = _useState18[1];

  var timeRafHandler = React.useRef(0);
  var initialLoadedTime = React.useRef(+new Date());

  var _useState19 = React.useState(0),
      _useState20 = _slicedToArray(_useState19, 2),
      time = _useState20[0],
      setTime = _useState20[1]; // [TODO] (optional) get value from url search, state 필요?  hls.js?


  var _useState21 = React.useState(0),
      _useState22 = _slicedToArray(_useState21, 2),
      seekTime = _useState22[0],
      setSeekTime = _useState22[1];

  var stateBeforeSeekStart = React.useRef({
    paused: false
  });

  var _useState23 = React.useState(0),
      _useState24 = _slicedToArray(_useState23, 2),
      elapsedSecondsFromLoaded = _useState24[0],
      setElapsedSecondsFromLoaded = _useState24[1]; // 로드 이후 지난 시간 -> hls.js?


  var _useState25 = React.useState((_video$duration = video.duration) !== null && _video$duration !== void 0 ? _video$duration : 0),
      _useState26 = _slicedToArray(_useState25, 2),
      duration = _useState26[0],
      setDuration = _useState26[1];

  var _useState27 = React.useState(1),
      _useState28 = _slicedToArray(_useState27, 2),
      volume = _useState28[0],
      setVolume = _useState28[1]; // [TODO] memorize to LocalStorage


  var _useState29 = React.useState(false),
      _useState30 = _slicedToArray(_useState29, 2),
      isMuted = _useState30[0],
      setMuted = _useState30[1]; // [TODO] memorize to LocalStorage


  var _useState31 = React.useState(true),
      _useState32 = _slicedToArray(_useState31, 2),
      autoplayable = _useState32[0],
      setAutoplayable = _useState32[1];

  var volumebarRef = React.useRef(null);
  var volumebarRect = React.useRef(null);
  var volumebarWidth = React.useRef(40); // [TODO] improve calculate logic for dynamic element dimension

  var _useState33 = React.useState({
    width: 0,
    height: 0
  }),
      _useState34 = _slicedToArray(_useState33, 2);
      _useState34[0];
      var setVideoDimension = _useState34[1];

  var _useState35 = React.useState({
    width: 0,
    height: 0
  }),
      _useState36 = _slicedToArray(_useState35, 2),
      containerDimension = _useState36[0],
      setContainerDimension = _useState36[1];

  var _useState37 = React.useState(false),
      _useState38 = _slicedToArray(_useState37, 2),
      isFullscreen = _useState38[0],
      setFullscreen = _useState38[1];

  var _useState39 = React.useState(false),
      _useState40 = _slicedToArray(_useState39, 2);
      _useState40[0];
      var setWaiting = _useState40[1];

  var _useState41 = React.useState(true),
      _useState42 = _slicedToArray(_useState41, 2),
      isBuffering = _useState42[0],
      setBuffering = _useState42[1]; // switching true when buffering time over 1sec


  var _useState43 = React.useState([]),
      _useState44 = _slicedToArray(_useState43, 2),
      buffered = _useState44[0],
      setBuffered = _useState44[1];

  var bufferingTimeoutHandler = React.useRef(0);

  var _useState45 = React.useState(false),
      _useState46 = _slicedToArray(_useState45, 2);
      _useState46[0];
      var setSeeking = _useState46[1];

  var _useState47 = React.useState(false),
      _useState48 = _slicedToArray(_useState47, 2),
      isPaused = _useState48[0],
      setPaused = _useState48[1];

  var _useState49 = React.useState(false),
      _useState50 = _slicedToArray(_useState49, 2),
      isEnded = _useState50[0],
      setEnded = _useState50[1];

  var _useState51 = React.useState(true),
      _useState52 = _slicedToArray(_useState51, 2),
      hasDelayHideControls = _useState52[0],
      setDelayHideControls = _useState52[1];

  var hideControlsTimeoutHandler = React.useRef(0);
  var tooltipRef = React.useRef(null);
  var seekbarRef = React.useRef(null);
  var seekbarRect = React.useRef(null);
  var memoizedChapterLabel = React.useRef('');
  var currentChapter = React.useMemo(function () {
    var _video$pose;

    if (!((_video$pose = video.pose) === null || _video$pose === void 0 ? void 0 : _video$pose.chapters)) return undefined;
    var chapterIndex = video.pose.chapters.findIndex(function (chapter) {
      return +chapter.startTime.toFixed(5) - 0.0001 <= time && +chapter.endTime.toFixed(5) + 0.0001 >= time;
    });
    return video.pose.chapters[chapterIndex];
  }, [video, time]);

  var createDelayHideControls = function createDelayHideControls() {
    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2000;
    setDelayHideControls(true);
    clearTimeout(hideControlsTimeoutHandler.current);
    hideControlsTimeoutHandler.current = window.setTimeout(function () {
      setDelayHideControls(false);
    }, delay);
  }; // Choose


  var onChoosePlayVideo = function onChoosePlayVideo() {
    if (!videoRef.current) return;
    videoRef.current.play();
  };

  var onChooseSingleplay = React.useCallback(function () {
    var _videoRef$current;

    if (screenfull__default['default'].isEnabled && screenfull__default['default'].isFullscreen) {
      screenfull__default['default'].exit();
    }

    onClickSingleplay();
    (_videoRef$current = videoRef.current) === null || _videoRef$current === void 0 ? void 0 : _videoRef$current.pause();
  }, [onClickSingleplay]);

  var onChooseSignIn = function onChooseSignIn() {
    auth === null || auth === void 0 ? void 0 : auth.signIn();
  };

  var onResize = function onResize() {
    if (!containerRef.current || !seekbarRef.current) return;
    var _containerRef$current = containerRef.current,
        width = _containerRef$current.clientWidth,
        height = _containerRef$current.clientHeight;
    setContainerDimension({
      width: width,
      height: height
    });
    seekbarRect.current = seekbarRef.current.getBoundingClientRect();

    if (volumebarRef.current) {
      volumebarRect.current = volumebarRef.current.getBoundingClientRect();
    }
  };

  var onFocus = function onFocus(e) {
    createDelayHideControls();
  };

  var bufferedEdgeProgress = React.useMemo(function () {
    var _ref2, _buffered;

    return (_ref2 = ((_buffered = buffered[buffered.length - 1]) === null || _buffered === void 0 ? void 0 : _buffered.end) / duration) !== null && _ref2 !== void 0 ? _ref2 : 0;
  }, [buffered, duration]);

  var getBuffered = function getBuffered() {
    if (!videoRef.current) return;
    var timeRangesObject = videoRef.current.buffered;
    var timeRanges = [];

    for (var count = 0; count < timeRangesObject.length; count++) {
      timeRanges.push({
        start: timeRangesObject.start(count),
        end: timeRangesObject.end(count)
      });
    }

    setBuffered(timeRanges);
  };

  var startBuffering = function startBuffering() {
    clearTimeout(bufferingTimeoutHandler.current);
    bufferingTimeoutHandler.current = window.setTimeout(function () {
      setBuffering(true);
    }, 1000);
  };

  var finishBuffering = function finishBuffering() {
    clearTimeout(bufferingTimeoutHandler.current);
    setBuffering(false);
  };

  var getCurrentTime = React.useCallback(function () {
    if (!videoRef.current) return;
    setTime(videoRef.current.currentTime);
    var elapsedSeconds = Math.floor((+new Date() - initialLoadedTime.current) / 1000);

    if (elapsedSeconds > elapsedSecondsFromLoaded) {
      setElapsedSecondsFromLoaded(elapsedSeconds);
    }

    timeRafHandler.current = requestAnimationFrame(getCurrentTime);
  }, [elapsedSecondsFromLoaded]);
  var isShowControls = React.useMemo(function () {
    if (isFeedbackPlaying) return false;
    if (status <= PlayerStatus.WAITING_FOR_CHOOSE) return false;
    return hasDelayHideControls || isSeekingMouseDown.current || isVolumeSliderMouseDown.current || onMouseOver && hasDelayHideControls || isPaused || isSeekingMouseDown.current || onMouseOverControls;
  }, [status, isFeedbackPlaying, hasDelayHideControls, isPaused, onMouseOverControls, onMouseOver]); // 게임 플레이 가능 여부

  var isShowActions = React.useMemo(function () {
    if (isFeedbackPlaying || mobileDeviceDetect.isMobile) return false;
    return typeof onClickSingleplay === 'function';
  }, [isFeedbackPlaying, onClickSingleplay, mobileDeviceDetect.isMobile]);
  var seekControl = React.useCallback(function (value) {
    if (isEnded && value === 'ArrowRight') return;
    if (!videoRef.current) return;
    var isKeyAction = typeof value !== 'number';
    var currentTime = videoRef.current.currentTime;
    var duration = videoRef.current.duration;
    var nextTime;

    if (isKeyAction) {
      setUserInteractionState(null);
      setUserInteractionState(value === 'ArrowLeft' ? 'seekPrev' : 'seekNext');
    }

    switch (value) {
      case 'ArrowLeft':
        nextTime = currentTime - 5 < 0 ? 0 : currentTime - 5;
        break;

      case 'ArrowRight':
        nextTime = currentTime + 5 > duration ? duration : currentTime + 5;
        break;

      default:
        nextTime = value;
    }

    videoRef.current.currentTime = nextTime;
    setTime(nextTime);
    createDelayHideControls();
  }, [isEnded]);
  var onLoadedMetadata = React.useCallback(function () {
    if (!videoRef.current) return;
    var videoEl = videoRef.current;
    var videoWidth = videoEl.videoWidth;
    var videoHeight = videoEl.videoHeight;
    var aspectRatio = videoEl.videoHeight / videoEl.videoWidth;
    setVideoDimension({
      width: videoWidth,
      height: videoHeight
    });
    setDuration(videoEl.duration);
    setMuted(videoEl.muted);
    var storedPlayerSettings = getStoragePlayerSettings();

    if (storedPlayerSettings) {
      if ('volume' in storedPlayerSettings) {
        if (isTouchDevice.current) {
          setVolume(1);
          videoEl.volume = 1;
        } else {
          var _storedPlayerSettings, _storedPlayerSettings2;

          setVolume((_storedPlayerSettings = storedPlayerSettings.volume) !== null && _storedPlayerSettings !== void 0 ? _storedPlayerSettings : 1);
          videoEl.volume = (_storedPlayerSettings2 = storedPlayerSettings.volume) !== null && _storedPlayerSettings2 !== void 0 ? _storedPlayerSettings2 : 1;
        }
      }

      if ('muted' in storedPlayerSettings) {
        if ( // store.shouldMobileDefaultMuted &&
        mobileDeviceDetect.isMobile && !autoplayable && !storedPlayerSettings.muted && options.autoplay) {
          setMuted(true);
          videoEl.muted = true;
        } else {
          var _storedPlayerSettings3, _storedPlayerSettings4;

          setMuted((_storedPlayerSettings3 = storedPlayerSettings.muted) !== null && _storedPlayerSettings3 !== void 0 ? _storedPlayerSettings3 : false);
          videoEl.muted = (_storedPlayerSettings4 = storedPlayerSettings.muted) !== null && _storedPlayerSettings4 !== void 0 ? _storedPlayerSettings4 : false;
        }
      }
    }

    if (aspectRatio > 1) {
      // Vertical
      setContainerDimension(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), {}, {
          height: Math.round(containerDimension.width * 0.5625)
        });
      });
    } else {
      // Horizontal
      setContainerDimension(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), {}, {
          height: videoHeight
        });
      });
    } // setLoadedMetadata(true);
    // safari ios - instead of canplay


    if (builtInHls && !options.autoplay) {
      setWaiting(false);
      finishBuffering();
    }

    if (isShowActions) {
      setStatus(PlayerStatus.WAITING_FOR_CHOOSE); // 영상 성격 결정되는 시점 ( 게임, 설명 )
    }

    if ($callbackOnLoaded) $callbackOnLoaded();
  }, [videoRef, containerDimension, isShowActions, $callbackOnLoaded, autoplayable]);
  var onCanPlay = React.useCallback(function () {
    setWaiting(false);
    finishBuffering();
  }, []);
  var onLoadedData = React.useCallback(function () {}, []);
  var onWaiting = React.useCallback(function () {
    setWaiting(true);
    startBuffering();
  }, []);
  var onSeeking = React.useCallback(function () {
    setSeeking(true);
    setEnded(false);
    createDelayHideControls();
  }, []);
  var onSeeked = React.useCallback(function () {
    setSeeking(false);
    getBuffered();
  }, []);
  var onPlaying = React.useCallback(function () {
    timeRafHandler.current = window.requestAnimationFrame(getCurrentTime);
    finishBuffering();
    setPaused(false);
    setStatus(PlayerStatus.PLAYING);
  }, [getCurrentTime]);
  var onProgress = React.useCallback(function () {
    getBuffered();
  }, []);
  var onTimeUpdate = React.useCallback(function () {
    if (!videoRef.current) return;
    setTime(videoRef.current.currentTime);
  }, []);
  var onPause = React.useCallback(function () {
    window.cancelAnimationFrame(timeRafHandler.current);
    setPaused(true);
    setStatus(PlayerStatus.PAUSED);
  }, []);
  var onEnded = React.useCallback(function () {
    setEnded(true);
  }, []);
  var togglePlay = React.useCallback(function (action, showInteractionFeedbackCircle) {
    if (!videoRef.current) return;
    var videoEl = videoRef.current;
    var nextAction = (action !== null && action !== void 0 ? action : isPaused) ? 'play' : 'pause';

    if (showInteractionFeedbackCircle) {
      setUserInteractionState(null);
      setUserInteractionState(nextAction);
    }

    switch (nextAction) {
      case 'play':
        videoEl.play();
        break;

      case 'pause':
        videoEl.pause();
        break;
    }
  }, [isPaused]);
  var volumeControl = React.useCallback(function (value) {
    if (!videoRef.current) return;
    var isKeyAction = typeof value !== 'number';
    var videoEl = videoRef.current;
    var currentVolume = videoEl.volume;
    var nextVolume;

    switch (value) {
      case 'ArrowUp':
        nextVolume = currentVolume + 0.05 > 0.99 ? 1 : currentVolume + 0.05;
        break;

      case 'ArrowDown':
        nextVolume = currentVolume - 0.05 < 0 ? 0 : currentVolume - 0.05;
        break;

      default:
        nextVolume = value;
    }

    var fixedNextVolume = Number(nextVolume.toFixed(2));

    if (isKeyAction) {
      var nextAction = value === 'ArrowUp' ? 'volumeUp' : 'volumeDown';
      setUserInteractionState(null);
      setUserInteractionState(!fixedNextVolume ? 'mute' : nextAction);
    }

    videoEl.volume = fixedNextVolume;
    setVolume(fixedNextVolume);
    setStoragePlayerSettings({
      volume: fixedNextVolume
    });
    createDelayHideControls(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var toggleMute = React.useCallback(function () {
    if (!videoRef.current) return;
    var nextMuted = !isMuted;

    if (!isMuted && volume === 0) {
      volumeControl(0.75);
    } else {
      videoRef.current.muted = nextMuted;
      setUserInteractionState(null);
      setUserInteractionState(nextMuted ? 'mute' : 'unmute');
      setMuted(nextMuted);
      setStoragePlayerSettings({
        muted: nextMuted
      });
    }
  }, [isMuted, volume, volumeControl]);
  var onClickDimmer = React.useCallback(function () {
    if (!autoplayable) {
      togglePlay('play');
      setAutoplayable(true);
      return;
    }

    if ( // store.shouldMobileDefaultMuted
    mobileDeviceDetect.isMobile && !autoplayable && isMuted) {
      toggleMute();
    }

    if (isTouchDevice.current) {
      if (!isShowControls) createDelayHideControls();
    } else {
      togglePlay(undefined, true);
    }
  }, [isShowControls, isMuted, togglePlay, toggleMute, autoplayable]);
  var IconUserInteractionState = React.useMemo(function () {
    switch (userInteractionState) {
      case 'play':
        return /*#__PURE__*/React__default['default'].createElement(SvgIcoSpPlay, null);

      case 'pause':
        return /*#__PURE__*/React__default['default'].createElement(SvgIcoSpPause, null);

      case 'mute':
        return /*#__PURE__*/React__default['default'].createElement(SvgIcoSpVolumeMuted, null);

      case 'unmute':
      case 'volumeUp':
        return /*#__PURE__*/React__default['default'].createElement(SvgIcoSpVolumeHigh, null);

      case 'volumeDown':
        return /*#__PURE__*/React__default['default'].createElement(SvgIcoSpVolumeMid, null);

      case 'seekPrev':
        return /*#__PURE__*/React__default['default'].createElement(SvgIcoSpSeekPrev, null);

      case 'seekNext':
        return /*#__PURE__*/React__default['default'].createElement(SvgIcoSpSeekNext, null);

      default:
        return /*#__PURE__*/React__default['default'].createElement("span", null);
    }
  }, [userInteractionState]);
  var toggleFullscreen = React.useCallback(function () {
    if (!containerRef.current || !videoRef.current) return;
    if (status === PlayerStatus.WAITING_FOR_CHOOSE) return;

    if (screenfull__default['default'].isEnabled) {
      screenfull__default['default'].toggle(containerRef.current);
    } else {
      if (videoRef.current.webkitSupportsFullscreen) videoRef.current.webkitEnterFullscreen();
    }
  }, [status]);
  var getNextTimeFromClientX = React.useCallback(function (xPos) {
    if (!seekbarRect.current) return 0;
    xPos = xPos - seekbarRect.current.left;
    if (xPos > seekbarRect.current.width) xPos = seekbarRect.current.width;
    if (xPos < 0) xPos = 0;
    return xPos / seekbarRect.current.width * duration;
  }, [duration]);

  var getNextVolumeFromClientX = function getNextVolumeFromClientX(xPos) {
    var _volumebarRect$curren;

    if (!volumebarRef.current) return 0;

    if (!((_volumebarRect$curren = volumebarRect.current) === null || _volumebarRect$curren === void 0 ? void 0 : _volumebarRect$curren.width)) {
      volumebarRect.current = volumebarRef.current.getBoundingClientRect();
    }

    if (!volumebarRect.current) return 0;
    xPos = xPos - volumebarRect.current.left;
    if (xPos > volumebarRect.current.width) xPos = volumebarRect.current.width;
    if (xPos < 0) xPos = 0;
    return xPos / volumebarRect.current.width;
  };

  var onContainerMouseMove = function onContainerMouseMove(e) {
    setMouseOver(true);
    createDelayHideControls();
  };

  var onContainerMouseLeave = function onContainerMouseLeave(e) {
    setMouseOver(false);
    setDelayHideControls(false);
  };

  var onControlsMouseMove = function onControlsMouseMove(e) {
    var _target$dataset;

    var target = e.target;
    if ((_target$dataset = target.dataset) === null || _target$dataset === void 0 ? void 0 : _target$dataset.dimmer) return;
    setMouseOverControls(true);
  };

  var onControlsMouseLeave = function onControlsMouseLeave(e) {
    setMouseOverControls(false);
  }; // Seek Slider <--


  var onGrabberStart = React.useCallback(function (e) {
    e.preventDefault();
    isSeekingMouseDown.current = true;
    stateBeforeSeekStart.current.paused = isPaused;
    var nextTime = getNextTimeFromClientX(e.clientX);

    if (document.activeElement instanceof HTMLElement) {
      var _containerRef$current2;

      (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.focus();
    }

    seekControl(nextTime);
    togglePlay('pause');
  }, [getNextTimeFromClientX, isPaused, seekControl, togglePlay]);
  var onGrabberDrag = React.useCallback(function (e) {
    if (!isSeekingMouseDown.current) return;
    e.preventDefault();
    var nextTime = getNextTimeFromClientX(e.clientX);
    setSeekTime(nextTime);
    seekControl(nextTime);
  }, [getNextTimeFromClientX, seekControl]);
  var onGrabberMove = React.useCallback(function (e) {
    e.preventDefault();
    var nextTime = getNextTimeFromClientX(e.clientX);
    setSeekTime(nextTime);
  }, [getNextTimeFromClientX]);
  var onGrabberStop = React.useCallback(function (e) {
    if (isSeekingMouseDown.current) {
      var nextTime = getNextTimeFromClientX(e.clientX);
      seekControl(nextTime);
      isSeekingMouseDown.current = false;
      createDelayHideControls();
      if (!stateBeforeSeekStart.current.paused) togglePlay('play');
    } else {
      if (!(e.target instanceof Element)) return;
      if (!e.target.isSameNode(seekbarRef.current)) return;
      if (!seekbarRef.current) return;
    }
  }, [getNextTimeFromClientX, seekControl, togglePlay]);

  var onGrabberTouchStart = function onGrabberTouchStart(e) {
    if (mobileDeviceDetect.isMobile && e.target === seekbarRef.current) {
      isSeekingMouseDown.current = true;
    }
  };

  var onGrabberTouchMove = function onGrabberTouchMove(e) {
    e.preventDefault();
    var nextTime = getNextTimeFromClientX(e.changedTouches[0].clientX);
    setSeekTime(nextTime);
    seekControl(nextTime);
  };

  var onGrabberTouchEnd = function onGrabberTouchEnd(e) {
    if (mobileDeviceDetect.isMobile && isSeekingMouseDown.current) {
      var _seekbarRef$current;

      isSeekingMouseDown.current = false;
      createDelayHideControls();
      var nextTime = getNextTimeFromClientX(e.changedTouches[0].clientX);
      setSeekTime(nextTime);
      seekControl(nextTime);
      (_seekbarRef$current = seekbarRef.current) === null || _seekbarRef$current === void 0 ? void 0 : _seekbarRef$current.blur();
      if (!stateBeforeSeekStart.current.paused) togglePlay('play');
    }
  }; // --> Seek Slider
  // Volume Slider <--


  var onVolumeGrabberStart = React.useCallback(function (e) {
    e.preventDefault();
    if (isMuted) toggleMute();
    isVolumeSliderMouseDown.current = true;
    var nextVolume = getNextVolumeFromClientX(e.clientX);
    volumeControl(nextVolume);
  }, [isMuted, toggleMute, volumeControl]);

  var onVolumeGrabberDrag = function onVolumeGrabberDrag(e) {
    if (!isVolumeSliderMouseDown.current) return;
    e.preventDefault();
    var nextVolume = getNextVolumeFromClientX(e.clientX);
    volumeControl(nextVolume);
  };

  var onVolumeGrabberStop = function onVolumeGrabberStop(e) {
    if (isVolumeSliderMouseDown.current) {
      var nextVolume = getNextVolumeFromClientX(e.clientX);
      volumeControl(nextVolume);
      isVolumeSliderMouseDown.current = false;
      createDelayHideControls();
    } else {
      if (!(e.target instanceof Element)) return;
      if (!e.target.isSameNode(seekbarRef.current)) return;
      if (!seekbarRef.current) return;
    }
  };

  var onVolumeGrabberTouchStart = function onVolumeGrabberTouchStart(e) {
    isVolumeSliderMouseDown.current = true;
  };

  var onVolumeGrabberTouchMove = function onVolumeGrabberTouchMove(e) {
    e.preventDefault();
    var nextVolume = getNextVolumeFromClientX(e.changedTouches[0].clientX);
    setSeekTime(nextVolume);
  };

  var onVolumeGrabberTouchEnd = function onVolumeGrabberTouchEnd(e) {
    if (isVolumeSliderMouseDown.current) {
      createDelayHideControls();
      isVolumeSliderMouseDown.current = false;
      var nextVolume = getNextVolumeFromClientX(e.changedTouches[0].clientX);
      volumeControl(nextVolume);
    }
  }; // --> Volume Slider
  // 파일 확장자 체크
  // src 할당
  // 게임 영상이 아닌 경우 (isShowActions) autoplayable 체크


  React.useEffect(function () {
    if (!videoRef.current) return;
    var extension = video.src.metadata.extension;
    var url = video.src.url;

    if (extension === '.m3u8') {
      if (Hls__default['default'].isSupported()) {
        hlsInstance.current = new Hls__default['default'](); // hlsInstance.current.startLevel = 0;

        hlsInstance.current.loadSource(url);
        hlsInstance.current.on(Hls__default['default'].Events.MANIFEST_PARSED, function (event, data) {
          setLevels(data.levels); // hlsInstance.current.startLevel = data.levels.length;
        });
        hlsInstance.current.attachMedia(videoRef.current);
        hlsInstance.current.on(Hls__default['default'].Events.MEDIA_ATTACHED, function () {
          var _videoRef$current2;

          if (isShowActions) return;

          if (!options.autoplay) {
            setAutoplayable(false);
            return;
          }

          var promise = (_videoRef$current2 = videoRef.current) === null || _videoRef$current2 === void 0 ? void 0 : _videoRef$current2.play();

          if (promise !== undefined) {
            promise.then(function (_) {
              setAutoplayable(true);
            })["catch"](function (error) {
              setAutoplayable(false);

              if (videoRef.current && mobileDeviceDetect.isMobile) {
                setMuted(true);
                videoRef.current.muted = true;
                videoRef.current.play();
              }
            });
          }
        }); // safari ios
      } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
        var _videoRef$current3;

        videoRef.current.src = url;
        setBuiltInHls(true);
        if (isShowActions) return;

        if (!options.autoplay) {
          setAutoplayable(false);
          return;
        }

        var promise = (_videoRef$current3 = videoRef.current) === null || _videoRef$current3 === void 0 ? void 0 : _videoRef$current3.play();

        if (promise !== undefined) {
          promise.then(function (_) {
            setAutoplayable(true);
          })["catch"](function (error) {
            setAutoplayable(false);

            if (videoRef.current && mobileDeviceDetect.isMobile) {
              setMuted(true);
              videoRef.current.muted = true;
              videoRef.current.play();
            }
          });
        }
      } //mp4

    } else {
      var _videoRef$current4;

      videoRef.current.src = url;

      if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
        setBuiltInHls(true);
      }

      if (isShowActions) return;

      if (!options.autoplay) {
        setAutoplayable(false);
        return;
      }

      var _promise = (_videoRef$current4 = videoRef.current) === null || _videoRef$current4 === void 0 ? void 0 : _videoRef$current4.play();

      if (_promise !== undefined) {
        _promise.then(function (_) {
          setAutoplayable(true);
        })["catch"](function (error) {
          if (!videoRef.current) return;
          setAutoplayable(false);

          if (videoRef.current && mobileDeviceDetect.isMobile) {
            setMuted(true);
            videoRef.current.muted = true;
            videoRef.current.play();
          }
        });
      }
    }

    return function () {
      var _hlsInstance$current;

      (_hlsInstance$current = hlsInstance.current) === null || _hlsInstance$current === void 0 ? void 0 : _hlsInstance$current.destroy();
    };
  }, [video.src]); // 이벤트 리스너

  React.useEffect(function () {
    isTouchDevice.current = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    setMounted(true);
    document.addEventListener('webkitfullscreenchange', onResize);
    window.addEventListener('resize', onResize);
    window.addEventListener('mousemove', onVolumeGrabberDrag, {
      capture: true
    });
    window.addEventListener('mouseup', onVolumeGrabberStop, {
      capture: true
    });
    if (!containerRef.current || !controlsRef.current || !seekbarRef.current || !volumebarRef.current) return;
    createDelayHideControls();
    var container = containerRef.current;
    var controls = controlsRef.current;
    var width = container.clientWidth,
        height = container.clientHeight;
    setContainerDimension({
      width: width,
      height: height
    });
    container.focus();
    container.addEventListener('mousemove', onContainerMouseMove);
    container.addEventListener('mouseleave', onContainerMouseLeave);
    controls.addEventListener('mousemove', onControlsMouseMove);
    controls.addEventListener('mouseleave', onControlsMouseLeave);
    seekbarRect.current = seekbarRef.current.getBoundingClientRect();
    volumebarRect.current = volumebarRef.current.getBoundingClientRect();

    function onChangeFullscreen() {
      if (screenfull__default['default'].isEnabled) {
        setFullscreen(screenfull__default['default'].isFullscreen);
        createDelayHideControls();
      }
    }

    screenfull__default['default'].isEnabled && screenfull__default['default'].on('change', onChangeFullscreen);
    return function () {
      clearTimeout(hideControlsTimeoutHandler.current);
      clearTimeout(bufferingTimeoutHandler.current);
      screenfull__default['default'].isEnabled && screenfull__default['default'].off('change', onChangeFullscreen);
      document.removeEventListener('webkitfullscreenchange', onResize);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('mousemove', onVolumeGrabberDrag);
      window.removeEventListener('mouseup', onVolumeGrabberStop);
      window.cancelAnimationFrame(timeRafHandler.current);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(function () {
    if (isFeedbackPlaying && isMuted) toggleMute(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFeedbackPlaying]);
  React.useEffect(function () {
    window.addEventListener('mousemove', onGrabberDrag, {
      capture: true
    });
    window.addEventListener('mouseup', onGrabberStop, {
      capture: true
    });
    return function () {
      window.removeEventListener('mousemove', onGrabberDrag, {
        capture: true
      });
      window.removeEventListener('mouseup', onGrabberStop, {
        capture: true
      });
    };
  }, [onGrabberDrag, onGrabberStop]); // 키보드 제어

  React.useEffect(function () {
    var container = containerRef.current;
    container === null || container === void 0 ? void 0 : container.addEventListener('keydown', onKeyDown);

    function onKeyDown(e) {
      if (status === PlayerStatus.WAITING_FOR_CHOOSE) return;
      var videoEl = videoRef.current;
      var target = e.target;
      var focusedControl;

      if (target instanceof HTMLElement) {
        if (target.dataset.controls) focusedControl = target.dataset.controls;
      }

      if (isFeedbackPlaying) ; else {
        // Allowed when only not feedback playing
        if (focusedControl) {
          switch (focusedControl) {
            case 'seek':
              switch (e.code) {
                case 'ArrowUp':
                case 'ArrowRight':
                  seekControl('ArrowRight');
                  e.preventDefault();
                  break;

                case 'ArrowDown':
                case 'ArrowLeft':
                  seekControl('ArrowLeft');
                  e.preventDefault();
                  break;
              }

              break;

            case 'volume':
              switch (e.code) {
                case 'ArrowUp':
                case 'ArrowRight':
                  volumeControl('ArrowUp');
                  e.preventDefault();
                  break;

                case 'ArrowDown':
                case 'ArrowLeft':
                  volumeControl('ArrowDown');
                  e.preventDefault();
                  break;
              }

              break;
          }
        }

        if (e.shiftKey || e.ctrlKey || e.altKey || e.metaKey) ; else {
          switch (e.code) {
            case 'Home':
              e.preventDefault();
              seekControl(0);
              break;

            case 'End':
              e.preventDefault();
              seekControl(videoEl.duration);
              break;

            case 'KeyF':
              e.preventDefault();
              toggleFullscreen();
              break;

            case 'KeyM':
              e.preventDefault();
              toggleMute();
              createDelayHideControls();
              break;

            case 'Space':
              e.preventDefault();
              togglePlay(undefined, true);
              break;

            case 'ArrowLeft':
            case 'ArrowRight':
              if (!focusedControl) {
                e.preventDefault();
                seekControl(e.code);
              }

              break;

            case 'ArrowUp':
            case 'ArrowDown':
              if (!focusedControl) {
                e.preventDefault();
                volumeControl(e.code);
              }

              break;
          }
        }
      } // Always allowed shortcuts.


      if (e.shiftKey || e.ctrlKey || e.altKey || e.metaKey) ;
    }

    return function () {
      container === null || container === void 0 ? void 0 : container.removeEventListener('keydown', onKeyDown);
    };
  }, [isFeedbackPlaying, status, isPaused, isMuted, volume, toggleFullscreen, toggleMute, togglePlay, seekControl, volumeControl]);
  return /*#__PURE__*/React__default['default'].createElement(PlayerContainer, {
    ref: containerRef,
    id: id,
    tabIndex: 0,
    onFocusCapture: onFocus
  }, status === PlayerStatus.WAITING_FOR_CHOOSE && /*#__PURE__*/React__default['default'].createElement(ChoosePanel, {
    style: {
      backgroundImage: "url(".concat(getVideoThumbnailUrl((_video$thumbnails = video.thumbnails) !== null && _video$thumbnails !== void 0 ? _video$thumbnails : [], 'highest'), ")")
    }
  }, isAuthenticated ? /*#__PURE__*/React__default['default'].createElement(ChooseArea, {
    chooseType: "singleplay",
    "data-active": hoveredChoosePanel === 'singleplay' || !hoveredChoosePanel ? 'true' : 'false',
    "data-disabled": "false",
    onMouseEnter: function onMouseEnter() {
      return setHoveredChoosePanel('singleplay');
    },
    onMouseLeave: function onMouseLeave() {
      return setHoveredChoosePanel(null);
    },
    onClick: onChooseSingleplay
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "symbol"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "btn-symbol"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "icon"
  }, /*#__PURE__*/React__default['default'].createElement(SvgIcoSpChooseSingleplay, {
    width: "70",
    height: "70"
  })), /*#__PURE__*/React__default['default'].createElement("strong", {
    className: "text"
  }, locale[locale$1]['watch.choosable.singleplay'])))) : /*#__PURE__*/React__default['default'].createElement(ChooseArea, {
    chooseType: "singleplay",
    "data-active": hoveredChoosePanel === 'singleplay' || !hoveredChoosePanel ? 'true' : 'false',
    "data-disabled": "false",
    onMouseEnter: function onMouseEnter() {
      return setHoveredChoosePanel('singleplay');
    },
    onMouseLeave: function onMouseLeave() {
      return setHoveredChoosePanel(null);
    },
    onClick: onChooseSignIn
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "symbol"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "btn-symbol"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "icon"
  }, /*#__PURE__*/React__default['default'].createElement(SvgIcoSpChooseSingleplay, {
    width: "70",
    height: "70"
  })), /*#__PURE__*/React__default['default'].createElement("strong", {
    className: "text"
  }, locale[locale$1]['watch.choosable.singleplay.authreq'])))), /*#__PURE__*/React__default['default'].createElement(ChooseArea, {
    chooseType: "play",
    "data-active": hoveredChoosePanel === 'play' || !hoveredChoosePanel ? 'true' : 'false',
    "data-disabled": "false",
    onMouseEnter: function onMouseEnter() {
      return setHoveredChoosePanel('play');
    },
    onMouseLeave: function onMouseLeave() {
      return setHoveredChoosePanel(null);
    },
    onClick: onChoosePlayVideo
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "symbol"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "btn-symbol"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "icon"
  }, /*#__PURE__*/React__default['default'].createElement(SvgIcoSpChoosePlay, {
    width: "70",
    height: "70"
  })), /*#__PURE__*/React__default['default'].createElement("strong", {
    className: "text"
  }, locale[locale$1]['watch.choosable.play']))))), /*#__PURE__*/React__default['default'].createElement(ControlPanel, {
    ref: controlsRef,
    isTouchDevice: isTouchDevice.current
  }, /*#__PURE__*/React__default['default'].createElement(ControlPanelDimmer, {
    onClick: function onClick() {
      return onClickDimmer();
    },
    "aria-hidden": isShowControls ? 'false' : 'true',
    "data-dimmer": "true"
  }), mobileDeviceDetect.isMobile && /*#__PURE__*/React__default['default'].createElement("div", {
    key: "interaction-feedback-controls",
    className: "sp-interaction-feedback-controls"
  }, !options.autoplay && !autoplayable && !isBuffering && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-interaction-feedback-controls-circle",
    onClick: function onClick() {
      var _videoRef$current5;

      (_videoRef$current5 = videoRef.current) === null || _videoRef$current5 === void 0 ? void 0 : _videoRef$current5.play();
    },
    style: {
      zIndex: 20,
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-interaction-feedback-controls-content"
  }, /*#__PURE__*/React__default['default'].createElement(SvgIcoSpPlay, null)))), (!mobileDeviceDetect.isMobile || (clientWidth !== null && clientWidth !== void 0 ? clientWidth : 0) >= 1024) && [/*#__PURE__*/React__default['default'].createElement("div", {
    key: "interaction-feedback-volume",
    className: "sp-interaction-feedback-volume"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-interaction-feedback-volume-content",
    "aria-hidden": userInteractionState === 'mute' || userInteractionState === 'unmute' || userInteractionState === 'volumeUp' || userInteractionState === 'volumeDown' ? 'false' : 'true'
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "text"
  }, userInteractionState === 'mute' ? '0%' : (volume * 100).toFixed(0) + '%'))),
  /*#__PURE__*/
  // )}
  React__default['default'].createElement("div", {
    key: "interaction-feedback-controls",
    className: "sp-interaction-feedback-controls"
  }, !autoplayable && !isBuffering && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-interaction-feedback-controls-circle",
    onClick: function onClick() {
      var _videoRef$current6;

      (_videoRef$current6 = videoRef.current) === null || _videoRef$current6 === void 0 ? void 0 : _videoRef$current6.play();
    },
    style: {
      zIndex: 20,
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-interaction-feedback-controls-content"
  }, /*#__PURE__*/React__default['default'].createElement(SvgIcoSpPlay, null))), /*#__PURE__*/React__default['default'].createElement(reactTransitionGroup.CSSTransition, {
    "in": userInteractionState !== null,
    timeout: {
      enter: 475,
      exit: 0
    },
    classNames: "transition-user-interaction-feedback-controls",
    onEnter: function onEnter() {
      clearTimeout(userInteractionFeedbackCircleTimeoutHandler.current);
      userInteractionFeedbackCircleTimeoutHandler.current = window.setTimeout(function () {
        setUserInteractionState(null);
      }, 475);
    },
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-interaction-feedback-controls-circle"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-interaction-feedback-controls-content"
  }, IconUserInteractionState))))], /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-controls-wrapper",
    "data-active": isShowControls ? 'true' : 'false'
  }, mobileDeviceDetect.isMobile && !autoplayable && // store.shouldMobileDefaultMuted && //[TODO]
  isMuted && /*#__PURE__*/React__default['default'].createElement(reactTransitionGroup.CSSTransition, {
    "in": elapsedSecondsFromLoaded < 5,
    timeout: 300,
    classNames: "transition-mobile-unmute",
    mountOnEnter: true
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-mobile-unmute"
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    type: "button",
    className: "btn-unmute",
    onClick: function onClick() {
      return toggleMute();
    }
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "icon"
  }, /*#__PURE__*/React__default['default'].createElement(SvgIcoSpVolumeMobileUnmute, {
    width: "18",
    height: "18"
  })), /*#__PURE__*/React__default['default'].createElement("strong", {
    className: "text"
  }, locale[locale$1]['player.mobile.unmute'])))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-indicator-wrap"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-buffering",
    "aria-hidden": isBuffering ? 'false' : 'true'
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-buffering-indicator"
  }))), isShowActions && status > PlayerStatus.WAITING_FOR_CHOOSE && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-actions",
    "aria-hidden": isShowControls ? 'false' : 'true'
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-actions-inner"
  }, isAuthenticated ? /*#__PURE__*/React__default['default'].createElement("button", {
    type: "button",
    className: "sp-action-btn type-singleplay",
    "data-disabled": "false",
    onClick: onChooseSingleplay
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "symbol"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "btn-symbol"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "icon"
  }, /*#__PURE__*/React__default['default'].createElement(SvgIcoSpChooseSingleplay, {
    width: "40",
    height: "40"
  })), /*#__PURE__*/React__default['default'].createElement("strong", {
    className: "text"
  }, locale[locale$1]['watch.choosable.singleplay'])))) : /*#__PURE__*/React__default['default'].createElement("button", {
    type: "button",
    className: "sp-action-btn type-singleplay",
    "data-disabled": "false",
    onClick: onChooseSignIn
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "symbol"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "btn-symbol"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "icon"
  }, /*#__PURE__*/React__default['default'].createElement(SvgIcoSpChooseSingleplay, {
    width: "40",
    height: "40"
  })), /*#__PURE__*/React__default['default'].createElement("strong", {
    className: "text"
  }, locale[locale$1]['watch.choosable.singleplay.authreq'])))))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-bottom",
    "aria-hidden": isShowControls ? 'false' : 'true'
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-progress"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-progress-inner",
    "data-active": isSeekingMouseDown.current ? 'true' : 'false'
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    ref: tooltipRef,
    className: "sp-progress-tooltip",
    style: {
      left: seekbarRect.current ? seekTime / duration * seekbarRect.current.width + 'px' : '0'
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-progress-tooltip-time"
  }, formatDigitToHHmmss(seekTime, true))), /*#__PURE__*/React__default['default'].createElement("div", {
    ref: seekbarRef,
    tabIndex: 0,
    className: "sp-progress-duration-padding",
    "data-controls": "seek",
    onMouseDownCapture: onGrabberStart,
    onMouseMove: onGrabberMove,
    onTouchStart: onGrabberTouchStart,
    onTouchMove: onGrabberTouchMove,
    onTouchEnd: onGrabberTouchEnd
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-progress-duration-inner"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-progress-duration-bar"
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-progress-buffered-bar",
    style: {
      transform: "scaleX(".concat(bufferedEdgeProgress, ")")
    }
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-progress-seeking-bar",
    style: {
      transform: "scaleX(".concat(seekbarRect.current ? seekTime / duration : 0, ")")
    }
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-progress-played",
    style: {
      transform: "scaleX(".concat(duration ? time / duration : 0, ")")
    }
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-grabber-wrapper"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-grabber"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-grabber-handle",
    onMouseDownCapture: onGrabberStart,
    onMouseMove: onGrabberMove,
    onTouchStart: onGrabberTouchStart,
    onTouchMove: onGrabberTouchMove,
    onTouchEnd: onGrabberTouchEnd,
    style: {
      transform: "translateX(".concat(seekbarRect.current ? time / duration * seekbarRect.current.width + 'px' : '0', ")")
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-grabber-handle-icon"
  })))))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-controls"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-controls-inner"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-controls-section control-left"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-control-item"
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    type: "button",
    onClick: function onClick() {
      return togglePlay(undefined, true);
    },
    "aria-label": "Play or Pause"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "sp-control-btn-content",
    tabIndex: -1
  }, isEnded ? /*#__PURE__*/React__default['default'].createElement(SvgIcoSpRestart, null) : isPaused ? /*#__PURE__*/React__default['default'].createElement(SvgIcoSpPlay, null) : /*#__PURE__*/React__default['default'].createElement(SvgIcoSpPause, null)))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-control-item"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-control-volume",
    "data-active": isVolumeSliderMouseDown.current ? 'true' : 'false'
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-control-volume-button"
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    type: "button",
    onClick: function onClick() {
      return toggleMute();
    }
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "sp-control-btn-content",
    tabIndex: -1
  }, isMuted || volume === 0 ? /*#__PURE__*/React__default['default'].createElement(SvgIcoSpVolumeMuted, null) : volume >= 0.5 ? /*#__PURE__*/React__default['default'].createElement(SvgIcoSpVolumeHigh, null) : /*#__PURE__*/React__default['default'].createElement(SvgIcoSpVolumeMid, null)))), !isTouchDevice.current && /*#__PURE__*/React__default['default'].createElement("div", {
    tabIndex: 0,
    "data-controls": "volume",
    className: "sp-control-volume-slider"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-control-volume-padding",
    onMouseDownCapture: onVolumeGrabberStart,
    onTouchStart: onVolumeGrabberTouchStart,
    onTouchMove: onVolumeGrabberTouchMove,
    onTouchEnd: onVolumeGrabberTouchEnd
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    ref: volumebarRef,
    className: "sp-control-volume-wrapper"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-control-volume-inner",
    onMouseDownCapture: onVolumeGrabberStart,
    onTouchStart: onVolumeGrabberTouchStart,
    onTouchMove: onVolumeGrabberTouchMove,
    onTouchEnd: onVolumeGrabberTouchEnd
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-control-volume-fill" // [TODO] improve calculate logic for dynamic element dimension
    ,
    style: {
      width: isMuted ? 0 : volume * volumebarWidth.current + 'px'
    }
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-control-volume-handle",
    style: {
      // [TODO] improve calculate logic for dynamic element dimension
      transform: "translateX(".concat(isMuted ? 0 : volume * volumebarWidth.current + 'px', ")")
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-control-volume-handle-icon"
  }))))))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-control-item"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-control-time"
  }, /*#__PURE__*/React__default['default'].createElement("strong", null, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "current"
  }, formatDigitToHHmmss(time, true)), /*#__PURE__*/React__default['default'].createElement("span", {
    className: "duration"
  }, "\xA0/\xA0", formatDigitToHHmmss(duration, true), ' ')))), /*#__PURE__*/React__default['default'].createElement(reactTransitionGroup.CSSTransition, {
    "in": currentChapter !== undefined,
    timeout: 1000,
    classNames: "transition-control-chapter",
    mountOnEnter: true,
    unmountOnExit: true,
    onEntering: function onEntering() {
      var _currentChapter$label;

      return memoizedChapterLabel.current = (_currentChapter$label = currentChapter === null || currentChapter === void 0 ? void 0 : currentChapter.label) !== null && _currentChapter$label !== void 0 ? _currentChapter$label : '';
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-control-item item-chapter"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-control-chapter"
  }, (currentChapter === null || currentChapter === void 0 ? void 0 : currentChapter.label) || memoizedChapterLabel.current)))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-controls-section control-right"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "sp-control-item"
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    type: "button",
    onClick: function onClick() {
      return toggleFullscreen();
    }
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "sp-control-btn-content",
    tabIndex: -1
  }, isFullscreen ? /*#__PURE__*/React__default['default'].createElement(SvgIcoSpFullscreenExit, null) : /*#__PURE__*/React__default['default'].createElement(SvgIcoSpFullscreenEnter, null)))))))))), /*#__PURE__*/React__default['default'].createElement(VideoContainer, {
    ref: videoContainerRef
  }, /*#__PURE__*/React__default['default'].createElement(VideoContainerInner, null, /*#__PURE__*/React__default['default'].createElement(Video, {
    id: "video",
    ref: videoRef,
    controlsList: "nodownload",
    playsInline: mobileDeviceDetect.isMobile ? true : (_options$playsinline = options === null || options === void 0 ? void 0 : options.playsinline) !== null && _options$playsinline !== void 0 ? _options$playsinline : false,
    muted: // store.shouldMobileDefaultMuted ? true :
    (_options$muted = options === null || options === void 0 ? void 0 : options.muted) !== null && _options$muted !== void 0 ? _options$muted : false,
    autoPlay: isShowActions ? false : options.autoplay,
    preload: "metadata" // onLoadStart={onLoadStart}
    ,
    onLoadedMetadata: onLoadedMetadata,
    onLoadedData: onLoadedData,
    onCanPlay: onCanPlay // onCanPlayThrough={onCanPlayThrough}
    ,
    onWaiting: onWaiting,
    onSeeking: onSeeking,
    onSeeked: onSeeked,
    onPlaying: onPlaying,
    onProgress: onProgress,
    onTimeUpdate: onTimeUpdate,
    onPause: onPause,
    onEnded: onEnded,
    poster: !!video.thumbnails ? getVideoThumbnailUrl((_video$thumbnails2 = video.thumbnails) !== null && _video$thumbnails2 !== void 0 ? _video$thumbnails2 : [], 'highest') : undefined
  }))));
};

var PlayerContainer = styled__default['default'].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  overflow: hidden;\n  display: flex;\n  position: relative;\n  height: 100%;\n  background-color: #000;\n  user-select: none;\n\n  &:focus {\n    outline: 0;\n  }\n\n  svg {\n    vertical-align: top;\n  }\n"])));
var ChoosePanel = styled__default['default'].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  display: flex;\n  z-index: 20;\n  background-color: rgba(9, 9, 9, 0.3);\n  background-repeat: no-repeat;\n  background-size: cover;\n"])), scMixinAbsoluteFull);
var ChooseArea = styled__default['default'].button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 180ms ease;\n  cursor: pointer;\n\n  &:hover,\n  &[data-active='true'] {\n    ", "\n\n    .btn-symbol {\n      width: auto;\n      padding: 0 32px 0 84px;\n\n      .text {\n        opacity: 1;\n      }\n    }\n  }\n\n  &[data-active='false'] {\n    .coming-soon {\n      display: none;\n    }\n  }\n\n  &[data-disabled='true']:hover {\n    background-color: rgba(182, 183, 184, 0.2) !important;\n    cursor: default;\n\n    .coming-soon .text {\n      opacity: 1;\n    }\n\n    .btn-symbol {\n      &,\n      & .icon {\n        background-color: #b6b7b8 !important;\n      }\n\n      .icon svg circle {\n        fill: #b6b7b8;\n      }\n    }\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  .symbol {\n    position: relative;\n  }\n\n  .coming-soon {\n    position: absolute;\n    bottom: 100%;\n    left: 0;\n    padding: 0 0 10px;\n\n    .text {\n      display: block;\n      min-width: 180px;\n      text-align: left;\n      font-weight: bold;\n      font-size: 18px;\n      line-height: 1.2;\n      text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n      color: #f5f6f8;\n      opacity: 0;\n      transition: opacity 90ms ease 90ms;\n    }\n  }\n\n  .btn-symbol {\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    position: relative;\n    width: 70px;\n    height: 70px;\n    padding: 0;\n    border-radius: 50px;\n    box-sizing: border-box;\n    transition: padding 180ms ease;\n\n    ", "\n\n    .icon {\n      position: absolute;\n      top: 0;\n      left: 0;\n      font-size: 0;\n      line-height: 0;\n      z-index: 2;\n\n      ", "\n    }\n\n    .text {\n      position: relative;\n      z-index: 1;\n      font-weight: bold;\n      font-size: 18px;\n      color: #f5f6f8;\n      vertical-align: middle;\n      white-space: nowrap;\n      opacity: 0;\n      transition: opacity 90ms ease;\n    }\n  }\n"])), function (_ref3) {
  var chooseType = _ref3.chooseType;

  switch (chooseType) {
    case 'singleplay':
      return react.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            background-color: rgba(82, 196, 26, 0.2);\n          "])));

    case 'multiplay':
      return react.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            background-color: rgba(245, 88, 0, 0.2);\n          "])));

    default:
      return react.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            background-color: rgba(129, 0, 55, 0.2);\n          "])));
  }
}, function (_ref4) {
  var chooseType = _ref4.chooseType;

  switch (chooseType) {
    case 'singleplay':
      return react.css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n            background-color: #52c41a;\n          "])));

    case 'multiplay':
      return react.css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n            background-color: #f55800;\n          "])));

    default:
      return react.css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n            background-color: #8100ff;\n          "])));
  }
}, function (_ref5) {
  var chooseType = _ref5.chooseType;

  switch (chooseType) {
    case 'singleplay':
      return react.css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n              background-color: #52c41a;\n            "])));

    case 'multiplay':
      return react.css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n              background-color: #f55800;\n            "])));

    default:
      return react.css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n              background-color: #8100ff;\n            "])));
  }
});
var ControlPanel = styled__default['default'].div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  ", ";\n  z-index: 10;\n\n  .sp-interaction-feedback-volume {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  .sp-interaction-feedback-volume-content {\n    display: inline-block;\n    position: relative;\n    top: 15%;\n    padding: 8px 14px;\n    background: rgba(9, 9, 9, 0.6);\n    border-radius: 3px;\n    text-align: center;\n\n    &[aria-hidden='true'] {\n      display: none;\n    }\n\n    .text {\n      font-weight: bold;\n      font-size: 20px;\n      line-height: 1.2;\n      color: #f5f6f8;\n    }\n  }\n\n  .sp-interaction-feedback-controls {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    z-index: 0;\n    width: 70px;\n    height: 70px;\n    text-align: center;\n    pointer-events: none;\n    cursor: default;\n    transform: translate(-50%, -50%);\n    transform-origin: 0 0;\n  }\n\n  .sp-interaction-feedback-controls-circle {\n    width: 70px;\n    height: 70px;\n\n    &::before {\n      ", ";\n      ", ";\n      z-index: 0;\n      background-color: #090909;\n      border-radius: 50%;\n      opacity: 0.5;\n    }\n\n    &.transition-user-interaction-feedback-controls-enter {\n      opacity: 0.6;\n      transform: scale(0.7);\n      animation: ", " 475ms ease;\n    }\n\n    &.transition-user-interaction-feedback-controls-enter-active {\n      opacity: 0;\n      transform: scale(1.3);\n    }\n\n    &.transition-user-interaction-feedback-controls-enter-done {\n      opacity: 0;\n      transform: scale(1.3);\n    }\n\n    &.transition-user-interaction-feedback-controls-exit {\n      opacity: 0;\n    }\n  }\n\n  .sp-interaction-feedback-controls-content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    position: relative;\n    z-index: 1;\n\n    svg {\n      width: 40px;\n      height: 40px;\n    }\n  }\n\n  .sp-controls-wrapper {\n    ", ";\n    transition: opacity 75ms ease;\n\n    &[data-active='true'] {\n      &::before {\n        opacity: 1;\n      }\n    }\n\n    &[data-active='false'] {\n      &::before {\n        opacity: 0;\n      }\n    }\n\n    & > div[aria-hidden='true'] {\n      opacity: 0;\n      pointer-events: none;\n    }\n\n    & > div[aria-hidden='false'] {\n      opacity: 1;\n    }\n\n    &::before {\n      display: block;\n      position: absolute;\n      top: 57.5%;\n      right: 0;\n      left: 0;\n      bottom: 0;\n      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%);\n      content: '';\n      pointer-events: none;\n      transition: all 100ms ease;\n    }\n  }\n\n  .sp-bottom {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 100;\n    padding: 5px 0 0;\n    transition: opacity 100ms ease-in-out;\n  }\n\n  .sp-actions {\n    position: absolute;\n    right: 13px;\n    bottom: 58px;\n    z-index: 100;\n  }\n\n  .sp-actions-inner {\n    text-align: right;\n  }\n\n  .sp-action-btn {\n    display: block;\n    margin-left: auto;\n    cursor: pointer;\n\n    & + .sp-action-btn {\n      margin-top: 12px;\n    }\n\n    &:focus {\n      outline: 0;\n    }\n\n    &[data-disabled='true'] {\n      cursor: default;\n\n      .btn-symbol {\n        background-color: #b6b7b8 !important;\n\n        &:hover {\n          transform: translateY(0);\n          box-shadow: none;\n        }\n      }\n\n      .icon svg circle {\n        fill: #b6b7b8;\n      }\n    }\n\n    &.type-singleplay .btn-symbol {\n      background-color: #52c41a;\n    }\n\n    &.type-multiplay .btn-symbol {\n      background-color: #f55800;\n    }\n\n    .symbol {\n      position: relative;\n    }\n\n    .coming-soon {\n      position: absolute;\n      right: 100%;\n      top: 0;\n      padding-right: 10px;\n\n      .text {\n        display: block;\n        min-width: 112px;\n        text-align: right;\n        font-weight: bold;\n        font-size: 15px;\n        line-height: 40px;\n        text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n        color: #f5f6f8;\n        opacity: 1;\n      }\n    }\n\n    .btn-symbol {\n      overflow: hidden;\n      display: flex;\n      align-items: center;\n      position: relative;\n      height: 40px;\n      padding: 0 22px 0 50px;\n      border-radius: 50px;\n      box-sizing: border-box;\n      box-shadow: none;\n      transition: all 180ms ease;\n\n      &:hover {\n        transform: translateY(-1px);\n        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n      }\n\n      .icon {\n        position: absolute;\n        top: 0;\n        left: 0;\n        font-size: 0;\n        line-height: 0;\n      }\n\n      .text {\n        font-weight: bold;\n        font-size: 15px;\n        line-height: 1.2;\n        color: #f5f6f8;\n        vertical-align: middle;\n        white-space: nowrap;\n        opacity: 1;\n      }\n    }\n  }\n\n  .sp-progress {\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 20;\n    height: 5px;\n  }\n\n  .sp-progress-inner {\n    position: relative;\n    width: calc(100% - 24px);\n    height: 100%;\n    margin: 0 auto;\n    touch-action: none;\n\n    &:hover {\n      .sp-progress-seeking-bar {\n        opacity: 1;\n      }\n    }\n\n    &:hover,\n    &[data-active='true'] {\n      .sp-progress-tooltip {\n        opacity: 1;\n        pointer-events: auto;\n      }\n\n      .sp-progress-duration-inner {\n        top: 0;\n        transform: scaleY(1);\n      }\n\n      .sp-grabber-handle-icon {\n        opacity: 1;\n        transform: scale(1);\n      }\n    }\n  }\n\n  .sp-progress-tooltip {\n    position: absolute;\n    bottom: calc(100% + 12px);\n    left: 0;\n    opacity: 0;\n    transform: translateX(-50%);\n    pointer-events: none;\n    transition: opacity 100ms ease;\n  }\n\n  .sp-progress-tooltip-time {\n    font-weight: bold;\n    font-size: 13px;\n    color: #f5f6f8;\n    text-shadow: 1px 0px 4px rgba(0, 0, 0, 0.25);\n  }\n\n  .sp-progress-duration-padding {\n    position: absolute;\n    top: -16px;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 10;\n    cursor: pointer;\n\n    &:focus {\n      outline: rgb(97, 157, 215) solid 2px;\n    }\n  }\n\n  .sp-progress-duration-inner {\n    position: absolute;\n    top: 1px;\n    right: 0;\n    left: 0;\n    height: 5px;\n    transform: scaleY(0.6);\n    transform-origin: 0 0;\n    transition: all 100ms ease;\n    cursor: pointer;\n  }\n\n  .sp-progress-duration-bar {\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 10;\n    height: 5px;\n    background-color: rgba(245, 246, 248, 0.15);\n    cursor: pointer;\n  }\n\n  .sp-progress-buffered-bar {\n    position: absolute;\n    z-index: 20;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(245, 246, 248, 0.25);\n    transform-origin: 0 0;\n  }\n\n  .sp-progress-seeking-bar {\n    display: ", ";\n    position: absolute;\n    z-index: 30;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(245, 246, 248, 0.4);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n\n  .sp-progress-played {\n    position: absolute;\n    z-index: 40;\n    width: 100%;\n    height: 100%;\n    background-color: #8100ff;\n    transform-origin: 0 0;\n  }\n\n  .sp-grabber-wrapper {\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 20;\n  }\n\n  .sp-grabber {\n    position: relative;\n    width: 100%;\n    height: 100%;\n  }\n\n  .sp-grabber-handle {\n    position: absolute;\n    top: -5px;\n    left: -7px;\n    transform-origin: 0 0;\n  }\n\n  .sp-grabber-handle-icon {\n    width: 15px;\n    height: 15px;\n    border-radius: 50%;\n    background-color: #8100ff;\n    transition: all 100ms ease;\n    cursor: pointer;\n\n    ", "\n  }\n\n  .sp-indicator-wrap {\n    position: static;\n  }\n\n  .sp-buffering {\n    display: block;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    min-width: 42px;\n    max-width: 70px;\n    width: 17%;\n    transform: translate(-50%, -50%);\n\n    @media (max-width: 767px) {\n      width: 11%;\n    }\n\n    &[aria-hidden='true'] {\n      display: none;\n    }\n\n    &::before {\n      display: block;\n      padding-top: 100%;\n      content: '';\n    }\n  }\n\n  .sp-buffering-indicator {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 4px solid #090909;\n    border-right-color: #dadada;\n    border-top-color: #dadada;\n    border-radius: 100%;\n    box-sizing: border-box;\n    opacity: 0.8;\n    animation: ", " 800ms infinite linear;\n  }\n\n  .sp-mobile-unmute {\n    position: absolute;\n    top: 24px;\n    left: 24px;\n    z-index: 10;\n    border-radius: 3px;\n    background-color: #f5f6f8;\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n\n    &.transition-mobile-unmute-enter {\n      max-width: 42px;\n    }\n\n    &.transition-mobile-unmute-enter-active {\n      max-width: 100%;\n      transition: max-width 300ms ease;\n    }\n\n    &.transition-mobile-unmute-exit {\n      max-width: 100%;\n\n      .text {\n        opacity: 1;\n        width: 100%;\n      }\n    }\n\n    &.transition-mobile-unmute-exit-active {\n      max-width: 42px;\n      transition: max-width 300ms ease;\n\n      .text {\n        opacity: 0;\n        width: 0;\n        transition: all 200ms ease 100ms;\n      }\n    }\n\n    &.transition-mobile-unmute-exit-done {\n      max-width: 42px;\n\n      .text {\n        opacity: 0;\n        width: 0;\n        margin-left: 0 !important;\n      }\n    }\n\n    .btn-unmute {\n      display: block;\n      overflow: hidden;\n      padding: 10px 12px;\n      line-height: 1;\n      white-space: nowrap;\n      text-align: left;\n\n      .icon {\n        display: inline-block;\n        vertical-align: top;\n      }\n\n      .text {\n        display: inline-block;\n        overflow: hidden;\n        position: relative;\n        top: 1px;\n        margin-left: 8px;\n        font-size: 13px;\n        line-height: 1.2;\n        color: #090909;\n        line-height: 18px;\n        vertical-align: top;\n      }\n    }\n  }\n\n  // Controls\n  .sp-controls {\n    position: relative;\n    z-index: 10;\n  }\n\n  .sp-controls-inner {\n    display: flex;\n    justify-content: space-between;\n    padding: 0 12px;\n  }\n\n  .sp-controls-section {\n    display: flex;\n    overflow: hidden;\n\n    &.control-left {\n      flex: 0 1 auto;\n    }\n\n    &.control-right {\n      flex: 0 1 auto;\n      min-width: 40px;\n    }\n  }\n\n  .sp-control-item {\n    button {\n      padding: 4px 2px;\n      cursor: pointer;\n\n      &:focus,\n      & .sp-control-btn-content {\n        outline: none;\n      }\n\n      &:focus > .sp-control-btn-content {\n        outline: #619dd7 solid 2px;\n      }\n\n      .sp-control-btn-content {\n        display: block;\n        padding: 4px 3px;\n\n        svg {\n          width: 24px;\n          height: 24px;\n        }\n      }\n    }\n\n    &.item-chapter {\n      flex: 0 1 auto;\n      overflow: hidden;\n    }\n\n    &.transition-control-chapter-enter {\n      opacity: 0;\n      transform: translateX(-12px);\n    }\n\n    &.transition-control-chapter-enter-active {\n      opacity: 1;\n      transform: translateX(0);\n      transition: opacity 200ms, transform 150ms;\n    }\n\n    &.transition-control-chapter-exit {\n      opacity: 1;\n      transform: translateX(0);\n    }\n\n    &.transition-control-chapter-exit-active {\n      opacity: 0;\n      transform: translateX(12px);\n      transition: opacity 200ms, transform 150ms;\n    }\n  }\n\n  .sp-control-volume {\n    display: flex;\n\n    &:hover,\n    &[data-active='true'] {\n      .sp-control-volume-slider {\n        width: 50px;\n        max-width: 50px;\n      }\n    }\n  }\n\n  .sp-control-volume-button {\n    //\n  }\n\n  .sp-control-volume-slider {\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    position: relative;\n    z-index: 1;\n    width: 0;\n    max-width: 0;\n    padding-top: 3px;\n    padding-bottom: 3px;\n    transition: max-width 100ms ease;\n\n    &:focus {\n      margin: -2px 0;\n      width: 50px;\n      max-width: 50px;\n      outline: #619dd7 solid 2px;\n    }\n  }\n\n  .sp-control-volume-padding {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 10;\n    /* padding: 3px 5px; */\n    box-sizing: border-box;\n    cursor: pointer;\n  }\n\n  .sp-control-volume-wrapper {\n    width: 100%;\n    height: 3px;\n    z-index: 20;\n  }\n\n  .sp-control-volume-inner {\n    position: relative;\n    width: calc(100% - 10px);\n    height: 100%;\n    margin: 0 5px;\n    background-color: rgba(245, 246, 248, 0.2);\n    cursor: pointer;\n  }\n\n  .sp-control-volume-fill {\n    height: 100%;\n    background-color: #f5f6f8;\n  }\n\n  .sp-control-volume-handle {\n    position: absolute;\n    top: -3px;\n    left: -5px;\n    transform-origin: 0 0;\n  }\n\n  .sp-control-volume-handle-icon {\n    width: 9px;\n    height: 9px;\n    border-radius: 50%;\n    background-color: #fff;\n    transition: all 100ms ease;\n    cursor: pointer;\n  }\n\n  .sp-control-time {\n    display: flex;\n    align-items: center;\n    padding: 5px 5px;\n    font-size: 15px;\n    line-height: 2;\n\n    .current {\n      color: #f5f6f8;\n    }\n\n    .duration {\n      color: #ddd;\n    }\n  }\n\n  .sp-control-chapter {\n    overflow: hidden;\n    position: relative;\n    padding: 5px;\n    color: #f5f6f8;\n    font-weight: bold;\n    font-size: 15px;\n    line-height: 2;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n"])), scMixinAbsoluteFull, scMixinPseudoBlock, scMixinAbsoluteFull, scAnimPlayerInteractionFeedbackCircle, scMixinAbsoluteFull, function (_ref6) {
  var isTouchDevice = _ref6.isTouchDevice;
  return isTouchDevice ? 'none' : 'block';
}, function (_ref7) {
  var isTouchDevice = _ref7.isTouchDevice;
  return !isTouchDevice && react.css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n        transform: scale(0);\n        opacity: 0;\n      "])));
}, scAnimBufferingIndcSpinner);
var ControlPanelDimmer = styled__default['default'].div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  ", ";\n  z-index: 10;\n"])), scMixinAbsoluteFull);
var VideoContainer = styled__default['default'].div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  flex: 1;\n  position: relative;\n  z-index: 0;\n"])));
var VideoContainerInner = styled__default['default'].div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  padding-top: 56.25%;\n"])));
var Video = styled__default['default'].video(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  ", ";\n  width: 100%;\n  height: 100%;\n"])), scMixinAbsoluteFull);

module.exports = Player;
